// extracted by mini-css-extract-plugin
export default {"plugin-menu-root":"_17TeU","pluginMenuRoot":"_17TeU"};